module.exports = __webpack_public_path__ + "img/photo-wide-3.49dff057.jpg";